import { render } from "./HipalProSubjects.vue?vue&type=template&id=f5c21814&ts=true"
import script from "./HipalProSubjects.ts?vue&type=script&lang=ts"
export * from "./HipalProSubjects.ts?vue&type=script&lang=ts"

import "./HipalProSubjects.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__